import React from 'react';
// import { observable } from 'mobx';
// import { observer } from 'mobx-react';
import { Modal, Spinner } from 'react-bootstrap'
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import warning from "../../assets/icons/warning.png";

class TuteeSignupModal extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = { 
      firstName:"",
      lastName:"",
      email:"",
      password:"",
      errors : {
        firstName:"",
        lastName:"",
        password: "",
        email: ""
      }
    }
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSignUpUser = (error,signUpUser) => {
    this.validate();
    if(error === ""){
      signUpUser();
    }
  }

  validate = () => {

    let errors = {
      firstName:"",
      lastName:"",
      password: '',
      email: ''
    }

    if( this.state.firstName === "" ){
      errors.firstName = 'First name is required';
    }
    
    if( this.state.lastName === "" ){
      errors.lastName = 'Last name is required';
    }

    if( this.state.email === "" ){
      errors.email = 'Email is required';
    }
    
    if( this.state.password === "" ){
      errors.password = 'Password is required';
    }

    this.setState({errors:errors})

  }

  handleFocus = (field) => {

    let errors = {
      firstName:"",
      lastName:"",
      password: '',
      email: ''
    }

    if(field === "firstName"){
      errors = {
        firstName: "",
        lastName: this.state.errors.lastName,
        email: this.state.errors.email,
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "lastName"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: "",
        email: this.state.errors.email,
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    if(field === "email"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: this.state.errors.lastName,
        email: "",
        password: this.state.errors.password
      }
      this.setState({errors:errors});
    }
    else if(field === "password"){
      errors = {
        firstName: this.state.errors.firstName,
        lastName: this.state.errors.lastName,
        email: this.state.errors.email,
        password: ""
      }
      this.setState({errors:errors});
    }
  }

  onClose = (onclose) => {
    const errors = {
      firstName:"",
      lastName:"",
      password: "",
      email: ""  
    }
    this.setState({
      firstName:"",
      lastName:"",
      email:"",
      password:"",
      errors : errors
    });
    onclose();
  }

  render() {
    const { 
      tutueeOpenModal, 
      onclose, 
      getInputKeyAndValue, 
      signUpUser, 
      openSignInModal, 
      onChangeReciveEmails, 
      error, 
      loading
    } = this.props;

    let warningEmail,warningPassword,warningFirstName,warningLastName;

    if(this.state.errors.firstName !== ""){
      warningFirstName = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.lastName !== ""){
      warningLastName = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.email !== ""){
      warningEmail = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    if(this.state.errors.password !== ""){
      warningPassword = (
        <img src={warning} alt="warning" width="14px" height="14px" style={{marginRight:"6px"}} />
      );
    }

    return (
      <Modal
        size="lg"
        centered
        className="signUp-tutor-modal"
        show={tutueeOpenModal} 
        onHide={() => this.onClose(onclose)}>

        <div className="text-center"
        style={{
        width:"100%",
        borderBottom:"0.3px solid lightgray",
        margin:"0px",
        paddingTop:"20px",
        paddingBottom:"20px",
        }}
        >
          <span 
          style={{
          width:"100%",
          fontFamily: "CircularStdMedium, Arial, sans-serif",
          fontSize:"16px",
          fontWeight:"bold",
          color:"black",
          textAlign:"center",
          fontStretch: "normal",
          fontStyle: "normal",
          letterSpacing: "normal",
          }}
          >
          Sign up as a parent or student
          </span>
        </div>
        <button
        onClick={() => this.onClose(onclose)}
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        style={{
        position: "absolute",
        zIndex: "9999",
        top:"15px",
        right:"50px",  
        width:"30px",
        height:"32px",
        paddingBottom:"15px",
        border:"none",
        backgroundColor:"white"
        }}
        >
          <span 
          aria-hidden="true" 
          style={{
          fontWeight:"bold",
          fontStrech:"normal",
          fontSize:"20px",
          color:"black",
          lineHeight:"normal",
          backgroundColor:"white"
          }}
          >
          x
          </span>
        </button>
        
        <Modal.Body style={{padding:"30px",marginBottom:"-25px"}}>
          <div className="container">
            <div className="row">
              <div className="col">

                <div className="form">

                  <div className="floating-label">      
                    <input 
                      id="firstName"
                      name="firstName" 
                      type="text" 
                      placeholder="First name"
                      className={this.state.errors.firstName ? 'errorInput' : null}
                      value={this.state.firstName}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={()=>this.handleFocus("firstName")}
                      onBlur={e => {
                      }}
                    />
                    <label className={this.state.errors.firstName ? 'label' : null}>
                      First name
                    </label>
                  </div>
                  <div className="error">{warningFirstName}{this.state.errors.firstName}</div>

                  <div className="floating-label">      
                    <input 
                      id="lastName"
                      name="lastName"
                      type="text"
                      placeholder="Last name"  
                      className={this.state.errors.lastName ? 'errorInput' : null}
                      value={this.state.lastName} 
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={()=>this.handleFocus("lastName")}
                      onBlur={e => {
                      }}
                    />
                    <label className={this.state.errors.lastName ? 'label' : null}>
                      Last name
                    </label>
                  </div>
                  <div className="error">{warningLastName}{this.state.errors.lastName}</div>

                  <div className="floating-label">      
                    <input 
                      id="email"
                      name="email" 
                      type="email" 
                      placeholder="Email"
                      className={this.state.errors.email ? 'errorInput' : null}
                      value={this.state.email}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={()=>this.handleFocus("email")}
                      onBlur={e => {
                      }}
                    />
                    <label className={this.state.errors.email ? 'label' : null}>
                      Email
                    </label>
                  </div>
                  <div className="error">{warningEmail}{this.state.errors.email}</div>

                  <div className="floating-label">      
                    <input 
                      id="password"
                      name="password"
                      type="password"
                      placeholder="Password"  
                      className={this.state.errors.password ? 'errorInput' : null}
                      value={this.state.password} 
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={()=>this.handleFocus("password")}
                      onBlur={e => {
                      }}
                    />
                    <label className={this.state.errors.password ? 'label' : null}>
                      Password
                    </label>
                  </div>
                  <div className="error">{warningPassword}{this.state.errors.password}</div>

                </div>

                <div>
                  <p 
                  style={{
                  width: "100%",
                  fontFamily: "OpenSans, Arial, sans-serif",
                  fontSize: "12.5px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "1.67",
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#535252",
                  marginTop:"-10px"
                  }}
                  >
                  Will send you members-only deals, inspiration, offers, promotion, policy updates via email.
                  </p>
                </div>
                
                <div className="checkBoxContainer">
                  <label className="container">
                    I don’t want to receive marketing messages from Askademia. I can also opt out of 
                    receiving these at any time in my account settings or via the link in the message.
                    <input type="checkbox" onChange={onChangeReciveEmails} />
                    <span className="checkmark"></span>
                  </label>
                </div>

                <div>
                  <p 
                  style={{
                  width: "100%",
                  fontFamily: "OpenSans, Arial, sans-serif",
                  fontSize: "12.5px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "1.67",
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#535252",
                  marginBottom:"15px"
                  }}
                  >
                  By selecting Sign up below, I agree to Askademia's <button 
                  style={{
                  fontWeight: "600",
                  color: "#007ab5",
                  textDecoration: "underline",
                  border:"none",
                  backgroundColor:"white",
                  padding:"0px"
                  }}
                  >
                    Terms and Conditions.
                    </button>
                  </p>
                </div>
                
                <button
                className="btn-lg-block login-btn mb-3"
                type="button" 
                onClick={ () => this.handleSignUpUser(error,signUpUser)}
                style={{ 
                height: "57px",
                padding: "18px",
                fontFamily: "CircularStdMedium, Arial, sans-serif",
                fontSize: "16px",
                fontWeight: "bold",
                fontStretch: "normal",
                fontStyle: "normal",
                lineHeight: "1.25",
                letterSpacing: "0.08px",
                textAlign: "center",
                color: "#ffffff",
                }}
                >
                {loading ? <span style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}><Spinner animation="border" style={{ width: "25px", height: "25px" }} /></span> : "Sign up"}
                </button>
                
                <hr style={{borderBottom:"0.1px solid lightgray",borderTop:"none",}} />
                
                <div style={{marginTop:"20px"}}>
                  <p 
                  style={{
                  width: "100%",
                  fontFamily: "OpenSans, Arial, sans-serif",
                  fontSize: "14px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#535252",
                  }}   
                  >Already have an account? <button
                    type="button" 
                    style={{
                    fontWeight: "600",
                    color: "#0f0f0f",
                    textDecoration: "underline",
                    border:"none",
                    backgroundColor:"white",
                    padding:"0px"
                    }}
                    onClick={openSignInModal} 
                    >
                      Log in
                    </button>
                  </p>
                </div>
              
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal >    
    );
  }
}

export default TuteeSignupModal;